module.exports = __webpack_public_path__ + "img/annotation-alert.c85772ed.svg";